/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconAlphabetKorean = createReactComponent("outline", "alphabet-korean", "IconAlphabetKorean", [["path", { "d": "M7 7h6c0 2.5 -1.593 8.474 -6 10", "key": "svg-0" }], ["path", { "d": "M16 5v14z", "key": "svg-1" }], ["path", { "d": "M16 12h2", "key": "svg-2" }]]);

export { IconAlphabetKorean as default };
//# sourceMappingURL=IconAlphabetKorean.mjs.map
